export default __webpack_public_path__ + "static/media/full_heart.24e6813c.svg";